import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { HomeIcon } from '@radix-ui/react-icons'

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-brand flex flex-col items-center justify-center text-white">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-2xl mb-8">Oops! Page not found</p>
      <Button asChild className="bg-forest hover:bg-forest/80 text-white">
        <Link to="/" className="flex items-center">
          <HomeIcon className="mr-2 h-4 w-4" />
          Go back home
        </Link>
      </Button>
    </div>
  )
}